export default __webpack_public_path__ + "static/media/Manchseter.8bccc083.webp";